(function(){
  var modal=document.getElementById('ar-modal'); if(!modal) return;
  var img=document.getElementById('ar-img'),tiras=document.getElementById('ar-tiras');
  var ref=document.getElementById('ar-ref'),nom=document.getElementById('ar-nom');
  var pa=document.getElementById('ar-antes'),ph=document.getElementById('ar-hoy');
  var tul=document.getElementById('ar-tallas'),menos=document.getElementById('ar-menos'),mas=document.getElementById('ar-mas');
  var cant=document.getElementById('ar-cant'),tope=document.getElementById('ar-tope');
  var sc=document.getElementById('ar-stock'),riel=document.getElementById('ar-riel');
  var uds=document.getElementById('ar-uds'),add=document.getElementById('ar-add');
  var ultimo=null,n=1,maxima=1,vsel=null,cerrando=null;
  function color(u){return u>10?'verde':(u>=6?'amarillo':'rojo');}
  function ancho(u){return u<=0?0:Math.max(5,Math.min(100,Math.round(u/30*100)));}
  function pintarStock(u){
    sc.className='ar-stock ar-stock--'+color(u);
    riel.style.width=ancho(u)+'%';
    uds.textContent=u<=0?'Agotada':(u>10?u.toLocaleString('es-CO')+' disponibles en esta talla':(u===1?'Queda 1 en esta talla':'Quedan '+u+' en esta talla'));
  }
  function pintarCant(){cant.textContent=n;menos.disabled=n<=1;mas.disabled=n>=maxima;add.disabled=maxima<1;
    tope.textContent=(maxima>=1&&n>=maxima)?'Máximo '+maxima+(maxima===10?' por pedido':' en esta talla'):'';}
  function elegir(b){
    vsel=b.dataset.v;
    tul.querySelectorAll('button').forEach(function(o){o.setAttribute('aria-pressed',o===b?'true':'false');});
    var u=parseInt(b.dataset.u,10)||0;
    pintarStock(u);maxima=Math.min(10,u);n=maxima>=1?1:0;pintarCant();
  }
  function abrir(card){
    clearTimeout(cerrando);ultimo=document.activeElement;
    var fotos=[].map.call(card.querySelectorAll('[data-gal]'),function(g){return g.getAttribute('data-gal');});
    img.src=fotos[0]||'';img.alt=card.dataset.nombre;
    tiras.innerHTML='';
    if(fotos.length>1){fotos.forEach(function(src,k){
      var b=document.createElement('button');b.type='button';b.setAttribute('aria-current',k===0?'true':'false');
      b.setAttribute('aria-label','Foto '+(k+1));
      var im=document.createElement('img');im.src=src;im.alt='';b.appendChild(im);
      b.addEventListener('click',function(){
        if(img.src===src)return;
        img.classList.add('cambiando');
        setTimeout(function(){img.src=src;img.classList.remove('cambiando');},180);
        tiras.querySelectorAll('button').forEach(function(o){o.setAttribute('aria-current','false');});
        b.setAttribute('aria-current','true');
      });
      tiras.appendChild(b);});}
    ref.textContent=card.dataset.ref?'Ref. '+card.dataset.ref:'JDC';
    nom.textContent=card.dataset.nombre;
    pa.textContent=card.dataset.antes;ph.textContent=card.dataset.hoy;
    tul.innerHTML='';
    var tallas=[];
    try{tallas=JSON.parse(card.dataset.tallas||'[]');}catch(e){}
    tallas.forEach(function(t){
      var li=document.createElement('li');var b=document.createElement('button');
      b.type='button';b.textContent=t.t;b.dataset.u=t.u;b.dataset.v=t.v;
      b.disabled=t.u<=0;b.setAttribute('aria-pressed','false');
      b.addEventListener('click',function(){elegir(b);});
      li.appendChild(b);tul.appendChild(li);
    });
    var pri=tul.querySelector('button:not(:disabled)');
    if(pri)elegir(pri);else{pintarStock(0);maxima=0;n=0;pintarCant();}
    add.textContent='Agregar al carrito';
    modal.hidden=false;document.body.style.overflow='hidden';
    void modal.querySelector('.ar-modal__caja').offsetHeight;
    modal.classList.add('abierto');
    var caja=modal.querySelector('.ar-modal__caja'),fondo=modal.querySelector('.ar-modal__fondo');
    setTimeout(function(){caja.style.setProperty('opacity','1','important');caja.style.setProperty('transform','none','important');fondo.style.setProperty('opacity','1','important');},20);
    modal.querySelector('.ar-modal__caja').focus();
  }
  function cerrar(){
    if(modal.hidden)return;
    modal.classList.remove('abierto');document.body.style.overflow='';
    var cj=modal.querySelector('.ar-modal__caja'),fd=modal.querySelector('.ar-modal__fondo');
    cj.style.removeProperty('opacity');cj.style.removeProperty('transform');fd.style.removeProperty('opacity');
    clearTimeout(cerrando);cerrando=setTimeout(function(){modal.hidden=true;},420);
    if(ultimo&&ultimo.focus)ultimo.focus();
  }
  document.querySelectorAll('.ar-pieza__foto').forEach(function(b){
    b.addEventListener('click',function(){abrir(b.closest('.ar-pieza'));});
  });
  modal.querySelectorAll('[data-cerrar]').forEach(function(e){e.addEventListener('click',cerrar);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)cerrar();});
  menos.addEventListener('click',function(){if(n>1){n--;pintarCant();}});
  mas.addEventListener('click',function(){if(n<maxima){n++;pintarCant();}});
  function abrirCajon(){
    var T=window.T4SThemeSP, J=window.jQuery;
    if(!T||!T.Drawer||!J){ document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); return; }
    try{ if(T.Cart&&T.Cart.getToFetch) T.Cart.getToFetch(); }catch(e){}
    setTimeout(function(){ try{ T.Drawer.opend(J('#t4s-mini_cart')); }catch(e){} }, 500);
  }
  add.addEventListener('click',function(){
    if(!vsel||maxima<1)return;
    add.disabled=true;add.textContent='Agregando...';
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:parseInt(vsel,10),quantity:n}]})})
      .then(function(r){return r.json();})
      .then(function(){
        add.textContent='Agregado ✓';
        abrirCajon();
        setTimeout(function(){ cerrar(); }, 550);
        setTimeout(function(){add.disabled=false;add.textContent='Agregar al carrito';},1800);
      })
      .catch(function(){add.disabled=false;add.textContent='No se pudo agregar';});
  });
})();